import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getMessaging, type Messaging } from 'firebase/messaging'
import { Capacitor } from '@capacitor/core'
import { env } from '../config/env'

let firebaseApp: FirebaseApp | null = null
let messaging: Messaging | null = null

const firebaseConfig = {
  apiKey: env.firebase.apiKey,
  authDomain: env.firebase.authDomain,
  projectId: env.firebase.projectId,
  storageBucket: env.firebase.storageBucket,
  messagingSenderId: env.firebase.messagingSenderId,
  appId: env.firebase.appId,
}

export function initializeFirebase(): FirebaseApp | null {
  if (firebaseApp) return firebaseApp

  if (!env.firebase.apiKey || !env.firebase.projectId) {
    console.warn('Firebase config missing, skipping initialization')
    return null
  }

  firebaseApp = initializeApp(firebaseConfig)
  return firebaseApp
}

export function getFirebaseMessaging(): Messaging | null {
  if (messaging) return messaging

  // Firebase JS Messaging only works on web, not on native platforms
  if (Capacitor.isNativePlatform()) return null

  const app = initializeFirebase()
  if (!app) return null

  try {
    messaging = getMessaging(app)
  } catch (e) {
    console.warn('Firebase Messaging not supported in this environment', e)
  }

  return messaging
}

export { firebaseApp, messaging }
